module.exports = "/_next/static/files/4e0b98ba3b134b0943d48289090927b5.jpg";